<template>
    <v-select v-model="selectedValue"
              :dense="dense"
              :disabled="disabled"
              :items="items"
              item-text="nombre"
              item-value="id"
              label="Deposito"
              @change="change"
              @focus="focus"
              :menu-props="{ auto: true, botton: true, offsetY: true }">
    </v-select>
</template>

<script>
    import { mapState, mapActions } from 'vuex';

    export default {
        name: 'selectDeposito',
        props: ['value', 'disabled', 'dense'],
        data: function () {
            return {
                pvalue: 0,
                ptexto: ''
            };
        },
        computed: {
            ...mapState('deposito', ['items']),

            selectedValue: {
                get() {
                    return this.value;
                },
                set(id) {
                    this.$emit('input', id);
                }
            }
       },
        methods: {
            ...mapActions('deposito', ['getAll']),

            change(id) {
                this.$emit('input', id);
                const deposito = this.items.find(item => item.id === id);

                if (!deposito) {
                    this.$emit('texto', '');
                    this.$emit('change', { id: null, nombre: '' });
                    return;
                }

                this.$emit('texto', deposito.nombre);
                this.$emit('change', deposito);
            },
            focus() {
                //this.pvalue = this.value;
                //this.ptexto = this.texto;
            }
        },
        mounted() {
            this.getAll();
        }
    };
</script>
